import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      img: this.el
        .closest('.insight-v2-masthead__container')
        .querySelector('.insight-v2-masthead__feature-articles')
        .querySelector('.image-v2__wrapper')
    };

    this.setHeight();
  }

  addListeners() {
    window.addEventListener('resize', this.setHeight.bind(this));
  }

  setHeight() {
    if (window.matchMedia('(max-width: 1025px)').matches) {
      return this.el.style.removeProperty('min-height');
    }

    this.el.style.minHeight = `${this.dom.img.offsetHeight}px`;
  }
}

export default Module;
